
import React from 'react';
import './index.scss';
import LevelDots from '../levelDots';

const LevelBar = (props) => {
  const { points, maxPointsByLevel, level } = props;

  return (
    <div className="profileLevelWrap">
      <div className="profileLevel">
        <LevelDots
          level={level - 1}
          trail
        />
        <div className="progressBar">
          <div
            className="bar"
            style={{ width: `${(points / maxPointsByLevel) * 100}%` }}
          />
        </div>
        <LevelDots
          level={level + 1}
          trail={false}
        />
      </div>
      <div className="progressBarCount">
        <span>{points}</span>
        <span>{maxPointsByLevel}</span>
      </div>
    </div>
  );
};

export default LevelBar;



// WEBPACK FOOTER //
// ./src/components/levelBar/index.js